import React, { useState } from "react";
import { jwtDecode } from "jwt-decode";
import moment from "moment-timezone";
import { Container, ButtonCriar } from "../styled/FiltroMobile";
import { requestData } from "../services/requests";
import { cpfMask, codigoUsoMask } from "../services/funcoesAuxiliares";
import Modal from "./modal";

const FiltrarDadosMobile = ({ setError, setFiltro }) => {
  const hoje = moment().format().split("T")[0];
  const mesPassado = moment().subtract(1, "month").format();
  const MesAnterior = mesPassado.split("T")[0];

  const user = JSON.parse(localStorage.getItem("user"));
  const { data } = jwtDecode(user);

  const [modalVisivel, setModalVisivel] = useState(false);
  const [filtroAtivo, setFiltroAtivo] = useState(false);

  const [filtro, setFiltroState] = useState({
    tipo: "cpf",
    valor: ""
  });

  const onChangeTipo = (e) => {
    setFiltroState({
      tipo: e.target.value,
      valor: ""
    });
  };

  const onChangeValor = (e) => {
    const { value } = e.target;
    let valorMascarado = value;

    if (filtro.tipo === "cpf") valorMascarado = cpfMask(value);
    if (filtro.tipo === "codigoUso") valorMascarado = codigoUsoMask(value);

    setFiltroState((prev) => ({
      ...prev,
      valor: valorMascarado
    }));
  };

  const filtrar = async () => {
    setFiltroAtivo(true);
    try {
      const filtroGestores = await requestData(
        `/carteiras/filtro?${filtro.tipo}=${filtro.valor}&gestor=${data.id}&selectedStatus=[]`
      );
      setFiltro(filtroGestores);
      setError(false);
    } catch (error) {
      setError(true);
    }
  };

  const limparFiltro = () => {
    setFiltro([]);
    setError(false);
    setFiltroAtivo(false);
    setFiltroState({ tipo: "cpf", valor: "" });
  };

  return (
    <Container>
      <div className="container_filtro">
        <form className="form_dados">
          <select id="filtroTipo" onChange={onChangeTipo} disabled={filtroAtivo} value={filtro.tipo}>
            <option value="cpf">CPF</option>
            <option value="codigoUso">Cod. Uso</option>
            <option value="name">Nome</option>
          </select>

          <input
            type="text"
            id={`filtro-${filtro.tipo}`}
            value={filtro.valor}
            onChange={onChangeValor}
            placeholder={
              filtro.tipo === "cpf"
                ? "CPF"
                : filtro.tipo === "codigoUso"
                ? "Cod. Uso"
                : "Nome"
            }
          />
        </form>

        <div className="container_buttons">
          <ButtonCriar
            className="btn_criar"
            onClick={() => setModalVisivel(true)}
          />
          {filtroAtivo ? (
            <button className="btn_limpar" onClick={limparFiltro}>
             <img
                src="https://cdn-icons-png.flaticon.com/512/3126/3126675.png"
                alt="Filtrar"
              />
            </button>
          ) : (
            <button type="button" className="btn_filtrar" onClick={filtrar}>
              <img
                src="https://cdn-icons-png.flaticon.com/512/2676/2676824.png"
                alt="Filtrar"
              />
            </button>
          )}
          {modalVisivel && (
            <Modal
              modalVisivel={modalVisivel}
              setModalVisivel={setModalVisivel}
            />
          )}
        </div>
      </div>
    </Container>
  );
};

export default FiltrarDadosMobile;
